<template>
    <div>
        <EnvProvider>
            <DeviceLayoutProvider :mobileThreshold="768">
                <GsapProvider>
                    <TimerProvider>
                        <MediaMetaProvider :data="mediaMetaData">
                            <FontLoaderProvider>
                                <ColorPaletteProvider>
                                    <slot />
                                </ColorPaletteProvider>
                            </FontLoaderProvider>
                        </MediaMetaProvider>
                    </TimerProvider>
                </GsapProvider>
            </DeviceLayoutProvider>
        </EnvProvider>
        <VersionPanel v-model="showVersionPanel" />
    </div>
</template>

<script setup>
    import { useNuxtApp } from '#app';
    import { ref } from 'vue';

    import { DeviceLayoutProvider, MediaMetaProvider } from '@resn/gozer-vue';

    import VersionPanel from '~/components/debug/VersionPanel.vue';
    import mediaMetaData from '~/media-metadata.json';
    import ColorPaletteProvider from '~/providers/ColorPaletteProvider';
    import EnvProvider from '~/providers/EnvProvider';
    import FontLoaderProvider from '~/providers/FontLoaderProvider';
    import GsapProvider from '~/providers/gsap/GsapProvider.vue';
    import { TimerProvider } from '~/providers/TimerProvider';

    const { $versionPanelVisible } = useNuxtApp();
    const showVersionPanel = $versionPanelVisible || ref(false);
</script>
